import moment from 'moment';

export const UploadDateFormat = 'MM/DD/YYYY';

const WeekMap = new Map([
  [0, 'Sunday'],
  [1, 'Monday'],
  [2, 'Tuesday'],
  [3, 'Wednesday'],
  [4, 'Thursday'],
  [5, 'Friday'],
  [6, 'Saturday']
]);

const MonthMap = new Map([
  [0, 'January'],
  [1, 'February'],
  [2, 'March'],
  [3, 'April'],
  [4, 'May'],
  [5, 'June'],
  [6, 'July'],
  [7, 'August'],
  [8, 'September'],
  [9, 'October'],
  [10, 'November'],
  [11, 'December'],
]);

const getPostfix = (cD = '', tD = '') => {
  const isSame = moment(tD).isSame(cD);
  const isBefore = moment(tD).isBefore(cD);

  // evaluate postfix
  let postfix = '';
  if (isSame) {
    postfix = ' - Today';
  } else if (isBefore) {
    postfix = ' - Past';
  }

  return postfix;
};

export const getHours = (hours = 0) => {
  if (hours === 0) return 12;
  if (hours > 12) return hours - 12;
  return hours;
};

/**
 * @param {number} t 
 * @returns {string}
 */
export const round = (t = 0) => {
  if (t < 10) return `0${t}`;
  return `${t}`;
};

export const getAMPM = (hours = 0) => hours < 12 ? 'am' : 'pm';

export const time = (_date = new Date()) => {
  const day = WeekMap.get(_date.getDay());
  const month = MonthMap.get(_date.getMonth());
  const date = _date.getDate();
  const year = _date.getFullYear();
  const hours = _date.getHours();
  const minutes = _date.getMinutes();
  const epochTime = _date.getTime();

  return {
    day,
    month,
    date,
    year,
    hours,
    minutes,
    epochTime,
  };
};

const DefaultCurrentAndTargetDate = { display: '', time: time() };

export const getCurrentAndTargetDate = (_date = new Date()) => {
  const m = time();
  const { day, month, date, year, hours, minutes, epochTime } = time(_date);
  const cD = `${m.year}-${m.month}-${m.date}`;
  const tD = `${year}-${month}-${date}`;
  return { cD: { display: cD, time: m }, tD: { display: tD, time: { day, month, date, year, hours, minutes, epochTime } } };
};

export const getFormattedDate = ({
  cD = { ...DefaultCurrentAndTargetDate },
  tD = { ...DefaultCurrentAndTargetDate }
}) => {
  const { day, month, date, year, hours, minutes, } = tD.time;
  const postfix = getPostfix(cD.display, tD.display);

  return {
    heading: `${day}, ${month} ${date}, ${year}`,
    time: `${round(getHours(hours))}:${round(minutes)} ${getAMPM(hours)}`,
    postfix,
    jsDate: tD.time,
  };
};

export const formattedDate = (date = '', format = UploadDateFormat) => moment(date).format(format);

export const getDateTime = ({
  date_UTC = ''
}) => {
  if (!date_UTC) {
    return {
      formatted: {
        date: '',
        time: '',
      },
      jsDate: {
        day: '',
        month: '',
        date: 0,
        year: 0,
        hours: 0,
        minutes: 0,
        epochTime: 0,
      },
    };
  }

  const localTime = date_UTC.toLocaleString();
  const { cD, tD } = getCurrentAndTargetDate(new Date(localTime));
  const { time, jsDate } = getFormattedDate({ cD, tD });
  return { formatted: { time, date: formattedDate(localTime, UploadDateFormat) }, jsDate };
};
